module.exports = __webpack_public_path__ + "static/img/about-profile-img-top.b1a2f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/about-profile-img-top.png
// module id = T9cp
// module chunks = 52